export const locales = {
	label: 'Menu utilisateur',
	logout: 'Déconnexion'
};
